import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  min-height: 70vh;
`;

export const PageTitle = styled.h1`
  font-family: 'Abel', sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 2rem;
`;

export const EmptyCart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;

  h2 {
    font-family: 'Abel', sans-serif;
    font-size: 1.8rem;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 1rem 0;
  }

  p {
    font-family: 'Abel', sans-serif;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin-bottom: 2rem;
  }
`;

export const EmptyIcon = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const ItemsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const GlobalTimer = styled.div<{ $warning?: boolean }>`
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ $warning }) => ($warning ? '#ff6b6b' : '#4caf50')};
  background-color: ${({ $warning }) => ($warning ? '#ffebee' : '#e8f5e9')};
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border: 2px solid ${({ $warning }) => ($warning ? '#ff6b6b' : '#4caf50')};
  text-align: center;
  animation: ${({ $warning }) => ($warning ? 'pulse 1s infinite' : 'none')};

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }
`;

export const CartItem = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr auto auto;
  gap: 1.5rem;
  padding: 1.5rem;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 80px 1fr;
    gap: 1rem;
  }
`;

export const ItemImage = styled.div`
  aspect-ratio: 1;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const NoImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Abel', sans-serif;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ItemBrand = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #b8964a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ItemModel = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ItemRef = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ReservationTimer = styled.div<{ $warning?: boolean }>`
  font-family: 'Abel', sans-serif;
  font-size: 0.85rem;
  color: ${({ $warning }) => ($warning ? '#ff6b6b' : '#4caf50')};
  margin-top: 0.5rem;
`;

export const ItemPrice = styled.div`
  font-family: 'Abel', sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: #b8964a;

  @media (max-width: 768px) {
    grid-column: 2;
    justify-self: start;
  }
`;

export const RemoveButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: all 0.2s;

  &:hover {
    background-color: #ff6b6b;
    color: white;
    border-color: #ff6b6b;
  }

  @media (max-width: 768px) {
    grid-column: 2;
    justify-self: end;
  }
`;

export const SummarySection = styled.div`
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 2rem;
  height: fit-content;
  position: sticky;
  top: 2rem;

  @media (max-width: 1024px) {
    position: static;
  }
`;

export const SummaryTitle = styled.h2`
  font-family: 'Abel', sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  font-family: 'Abel', sans-serif;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 1rem 0;
`;

export const SummaryTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  font-family: 'Abel', sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: #b8964a;
`;

export const CheckoutButton = styled.button`
  width: 100%;
  background-color: #b8964a;
  border: none;
  color: white;
  font-family: 'Abel', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 1.5rem;

  &:hover {
    background-color: #a07f3a;
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(184, 150, 74, 0.35);
  }
`;

export const ContinueButton = styled(CheckoutButton)``;

export const ContinueShoppingLink = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: 'Abel', sans-serif;
  font-size: 0.95rem;
  padding: 1rem;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: underline;

  &:hover {
    color: #b8964a;
  }
`;

export const SecurityNote = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 6px;
  margin-top: 1.5rem;

  span {
    font-size: 1.5rem;
  }

  p {
    font-family: 'Abel', sans-serif;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin: 0;
  }
`;